export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./crash-games.vue?vue&type=template&id=7619fb46"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/banners/casino-banners/crash-games.vue?vue&type=template&id=7619fb46
// module id = IlRJ
// module chunks = 0